import type { OdpovedTimeline } from '../api/JsdhNotifikaceService/generated/models/OdpovedTimeline';

export interface StatistikyReakce {
    prumernaDobaReakce: number | null;
    medianDobaReakce: number | null;
    minDobaReakce: number | null;
    maxDobaReakce: number | null;
    pocetVD: number;
    pocetS: number;
    pocetH: number;
    nejrychlejsiIds: number[];
}

const vypocitejMedian = (hodnoty: number[]): number | null => {
    if (hodnoty.length === 0) return null;
    const sorted = [...hodnoty].sort((a, b) => a - b);
    const mid = Math.floor(sorted.length / 2);
    return sorted.length % 2 !== 0 ? sorted[mid] : (sorted[mid - 1] + sorted[mid]) / 2;
};

export const najdiNejrychlejsi = (timeline: OdpovedTimeline[], pocet = 3): number[] => {
    const jedouTimeline = timeline.filter(t => t.odpoved === 'JEDU');
    const sorted = [...jedouTimeline]
        .filter(t => t.dobaReakceSekundy !== undefined && t.dobaReakceSekundy !== null)
        .sort((a, b) => a.dobaReakceSekundy - b.dobaReakceSekundy);
    return sorted.slice(0, pocet).map(t => t.id);
};

export const vypocitejStatistiky = (timeline: OdpovedTimeline[]): StatistikyReakce => {
    const jedouTimeline = timeline.filter(t => t.odpoved === 'JEDU');

    const dobyReakce = jedouTimeline
        .map(t => t.dobaReakceSekundy)
        .filter((d): d is number => d !== undefined && d !== null);

    const prumerna = dobyReakce.length > 0
        ? dobyReakce.reduce((a, b) => a + b, 0) / dobyReakce.length
        : null;
    const median = vypocitejMedian(dobyReakce);
    const min = dobyReakce.length > 0 ? Math.min(...dobyReakce) : null;
    const max = dobyReakce.length > 0 ? Math.max(...dobyReakce) : null;

    let pocetVD = 0, pocetS = 0, pocetH = 0;
    for (const odpoved of jedouTimeline) {
        if (odpoved.uzivatelFunkce?.length) {
            const kody = odpoved.uzivatelFunkce.map(f => f.kod);
            if (kody.includes('VD')) pocetVD++;
            else if (kody.includes('S')) pocetS++;
            else if (kody.includes('H')) pocetH++;
        }
    }

    const nejrychlejsiIds = najdiNejrychlejsi(timeline, 3);

    return {
        prumernaDobaReakce: prumerna,
        medianDobaReakce: median,
        minDobaReakce: min,
        maxDobaReakce: max,
        pocetVD,
        pocetS,
        pocetH,
        nejrychlejsiIds
    };
};

export const formatujDobuReakce = (sekundy: number | null): string => {
    if (sekundy === null) return '-';
    if (sekundy < 60) return `${Math.round(sekundy)} s`;
    const min = Math.floor(sekundy / 60);
    const sec = Math.round(sekundy % 60);
    return `${min} min ${sec} s`;
};
